export const CCRSWASTATUS = {
  FILE_CREATED_IN_LOCAL : 'FILE_CREATED_IN_LOCAL',
  STARTED_UPLOADING : 'STARTED_UPLOADING',
  FINISHED_UPLOADING : 'FINISHED_UPLOADING',
  UPLOAD_FAILED : 'UPLOAD_FAILED',
  PENDING : 'PENDING',
  SUCCESS : 'SUCCESS',
  ERROR : 'ERROR'

}